import {
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Box,
  Stack,
  useTheme,
  Divider
} from "@mui/material";
import ImageSlideshow from "../../components/ImageSlideShow";
import community_dept_img1 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-1.jpg";
import community_dept_img2 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-2.jpg";
import community_dept_img3 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-3.jpg";
import community_dept_img4 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-4.jpg";
import community_dept_img5 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-5.jpg";
import community_dept_img6 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-6.jpg";
import community_dept_img7 from "../../assets/images/facilities/infrastructure/departments/community_Dept/img-7.jpg";
import musculoskeletal_dept_img1 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_1.jpg";
import musculoskeletal_dept_img2 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_2.jpg";
import musculoskeletal_dept_img3 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_3.jpg";
import musculoskeletal_dept_img4 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_4.jpg";
import musculoskeletal_dept_img5 from "../../assets/images/facilities/infrastructure/departments/musculoskeletal_Dept/musculoskeletal_img_5.jpg";
import neuro_dept_img1 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-1.jpg";
import neuro_dept_img2 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-2.jpg";
import neuro_dept_img3 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-3.jpg";
import neuro_dept_img4 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-4.jpg";
import kinesiotherapy_dept_img1 from "../../assets/images/facilities/infrastructure/departments/kinesiotherapy_Dept/kinesiotherapy-img-1.jpg";
import kinesiotherapy_dept_img2 from "../../assets/images/facilities/infrastructure/departments/kinesiotherapy_Dept/kinesiotherapy-img-2.jpg";
import kinesiotherapy_dept_img3 from "../../assets/images/facilities/infrastructure/departments/kinesiotherapy_Dept/kinesiotherapy-img-3.jpg";
import kinesiotherapy_dept_img4 from "../../assets/images/facilities/infrastructure/departments/kinesiotherapy_Dept/kinesiotherapy-img-4.jpg";
import electrotherapy_dept_img1 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-1.jpg";
import electrotherapy_dept_img2 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-2.jpg";
import electrotherapy_dept_img3 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-3.jpg";
import electrotherapy_dept_img4 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-4.jpg";
import electrotherapy_dept_img5 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-5.jpg";
import electrotherapy_dept_img6 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-6.jpg";
import electrotherapy_dept_img7 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-7.jpg";
import electrotherapy_dept_img8 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-8.jpg";
import electrotherapy_dept_img9 from "../../assets/images/facilities/infrastructure/departments/electrotherapy_Dept/electrotherapy-img-9.jpg";
import cardio_dept_img1 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-1.jpg";
import cardio_dept_img2 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-2.jpg";
import cardio_dept_img3 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-3.jpg";
import cardio_dept_img4 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-4.jpg";
import cardio_dept_img5 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-5.jpg";
import cardio_dept_img6 from "../../assets/images/facilities/infrastructure/departments/cardio_Dept/cardio-img-6.jpg";
import { ZoomInRounded } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import { useState } from "react";

type ImageType = {
  src: string;
  alt: string;
};

type InfraObect = {
  title: string;
  description?: string;
  img?: Array<ImageType>;
  subItems?: Array<{
    name: string;
    img: Array<ImageType>;
    path?: string;
  }>;
};

const DepartmentData: Array<InfraObect> = [
  {
    title: "Departments",

    subItems: [
      {
        name: "Department of Kinesiotherapy & Physical Diagnosis",
        img: [
            { src: kinesiotherapy_dept_img1, alt: "kinesiotherapy_dept_img1" },
            { src: kinesiotherapy_dept_img2, alt: "kinesiotherapy_dept_img2" },
            { src: kinesiotherapy_dept_img3, alt: "kinesiotherapy_dept_img3" },
            { src: kinesiotherapy_dept_img4, alt: "kinesiotherapy_dept_img4" },
        ],
      },

      {
        name: "Department of Electrotherapy",
        img: [
            { src: electrotherapy_dept_img1, alt: "electrotherapy_dept_img1" },
            { src: electrotherapy_dept_img2, alt: "electrotherapy_dept_img2" },
            { src: electrotherapy_dept_img3, alt: "electrotherapy_dept_img3" },
            { src: electrotherapy_dept_img4, alt: "electrotherapy_dept_img4" },
            { src: electrotherapy_dept_img5, alt: "electrotherapy_dept_img5" },
            { src: electrotherapy_dept_img6, alt: "electrotherapy_dept_img6" },
            { src: electrotherapy_dept_img7, alt: "electrotherapy_dept_img7" },
            { src: electrotherapy_dept_img8, alt: "electrotherapy_dept_img8" },
            { src: electrotherapy_dept_img9, alt: "electrotherapy_dept_img9" },
        ],
      },

      {
        name: "Department of Musculoskeletal Physiotherapy",
        img: [
          { src: musculoskeletal_dept_img1, alt: "musculoskeletal_dept_img1" },
          { src: musculoskeletal_dept_img2, alt: "musculoskeletal_dept_img2" },
          { src: musculoskeletal_dept_img3, alt: "musculoskeletal_dept_img3" },
          { src: musculoskeletal_dept_img4, alt: "musculoskeletal_dept_img4" },
          { src: musculoskeletal_dept_img5, alt: "musculoskeletal_dept_img5" },
        ],
        path:'/department/musculoskeletal-physiotherapy'
      },

      {
        name: "Department of Neuro-Physiotherapy",
        img: [
            { src: neuro_dept_img1, alt: "neuro_dept_img1" },
            { src: neuro_dept_img2, alt: "neuro_dept_img2" },
            { src: neuro_dept_img3, alt: "neuro_dept_img3" },
            { src: neuro_dept_img4, alt: "neuro_dept_img4" },
        ],
        path:'/department/neuro-physiotherapy'
      },

      {
        name: "Department of Cardiovascular & Respiratory",
        img: [
            { src: cardio_dept_img1, alt: "cardio_dept_img1" },
            { src: cardio_dept_img2, alt: "cardio_dept_img2" },
            { src: cardio_dept_img3, alt: "cardio_dept_img3" },
            { src: cardio_dept_img4, alt: "cardio_dept_img4" },
            { src: cardio_dept_img5, alt: "cardio_dept_img5" },
            { src: cardio_dept_img6, alt: "cardio_dept_img6" },
        ],
        path:'/department/cardiovascular-&-respiratory-physiotherapy'
      },

      {
        name: "Department of Community Physiotherapy",
        img: [
          { src: community_dept_img1, alt: "community_dept_img1" },
          { src: community_dept_img2, alt: "community_dept_img2" },
          { src: community_dept_img3, alt: "community_dept_img3" },
          { src: community_dept_img4, alt: "community_dept_img4" },
          { src: community_dept_img5, alt: "community_dept_img5" },
          { src: community_dept_img6, alt: "community_dept_img6" },
          { src: community_dept_img7, alt: "community_dept_img7" },
        ],
        path:'/department/community-physiotherapy'
      },
    ],
  },
];

const Department = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();
  const theme = useTheme();
  return (
    <Stack
      sx={{ backgroundColor: "primary.light", p: { xs: 2, md: 3 } }}
      spacing={2}
      direction="row"
      alignItems="center"
      justifyContent="center"
      flexWrap={"wrap"}
    >
      {DepartmentData.map((item, index) => {
        const hasSubtabs =
          item?.subItems?.length && ((item?.subItems?.length > 0) as boolean);

        const isMultiImages = Array.isArray(item.img) && item?.img?.length > 1;

        const imageToShow = (item?.img ? item?.img[0].src : "") as string;

        return (
          <Grid
            key={index}
            item
            p={2}
            margin={"auto"}
            flexWrap={"wrap"}
            sx={{
              minWidth: {
                xs: "100%",
                md: hasSubtabs ? "100%" : 400,
              },
              maxWidth: {
                xs: "100%",
                md: hasSubtabs ? "100%" : 400,
              },
            }}
          >
            <Card
              sx={{
                alignContent: "space-between",
                // margin: 4,
                minWidth: {
                  xs: "100%",
                  md: hasSubtabs ? "100%" : 400,
                },
                maxWidth: {
                  xs: "100%",
                  md: hasSubtabs ? "100%" : 400,
                },
                minHeight: hasSubtabs ? "auto" : "380px",
                maxHeight: hasSubtabs ? "auto" : { xs: "380px", sm: "380px" },
              }}
            >
              {!hasSubtabs && (
                <>
                  {isMultiImages ? (
                    <Box sx={{ position: "relative" }}>
                      <ImageSlideshow
                        sx={{}}
                        images={item.img as Array<ImageType>}
                        showCaption={false}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item.title);
                          setSliderImages(item.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 99,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  ) : (
                    <Box sx={{ position: "relative" }}>
                      <CardMedia
                        component="img"
                        height="240px"
                        sx={{
                          pt: 1,
                          margin: "auto",
                          objectFit: "cover",
                        }}
                        image={imageToShow}
                        alt={item.title as string}
                      />
                      <Box
                        sx={{
                          position: "absolute" as "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                        onClick={() => {
                          setTitle(item.title);
                          setSliderImages(item.img);
                          setOpen(true);
                        }}
                      >
                        <ZoomInRounded
                          sx={{
                            color: "#fdd025",
                            zIndex: 2,
                            fontSize: "4rem",
                            "&:hover": {
                              fontSize: "6rem",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                  )}
                  <Divider sx={{ py: 1 }} />
                </>
              )}
              <CardContent>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.primary.contrastText,
                    }}
                  >
                    {item.title}
                  </Typography>

                  {item.description && (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        color: theme.palette.grey[900],
                        p: 2,
                      }}
                    >
                      {item.description}
                    </Typography>
                  )}
                </Box>

                {item?.subItems && (
                  <Box mt={2} sx={{ textAlign: "center", height: "60%" }}>
                    <Grid container spacing={2} mt={2}>
                      {item.subItems.map((subItem, idx) => {
                        const isMultiImages =
                          Array.isArray(subItem.img) &&
                          subItem?.img?.length > 1;

                        const imageToShow = (
                          subItem?.img ? subItem?.img[0].src : ""
                        ) as string;
                        return (
                          <Grid item xs={12} sm={6} key={idx}>
                            <Card
                              sx={{
                                width: "80%",
                                margin: 2,
                                minHeight: "360px",
                                // height: "60%",
                                // maxHeight: { xs: "auto", sm: "360px" },
                              }}
                            >
                              {isMultiImages ? (
                                <Box sx={{ position: "relative" }}>
                                  <ImageSlideshow
                                    sx={{}}
                                    images={subItem.img as Array<ImageType>}
                                    showCaption={false}
                                  />
                                  <Box
                                    sx={{
                                      position: "absolute" as "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                    }}
                                    onClick={() => {
                                      setTitle(subItem.name);
                                      setSliderImages(subItem.img);
                                      setOpen(true);
                                    }}
                                  >
                                    <ZoomInRounded
                                      sx={{
                                        color: "#fdd025",
                                        zIndex: 99,
                                        fontSize: "4rem",
                                        "&:hover": {
                                          fontSize: "6rem",
                                        },
                                      }}
                                    />
                                  </Box>
                                </Box>
                              ) : (
                                <Box sx={{ position: "relative" }}>
                                  <CardMedia
                                    component="img"
                                    height="240px"
                                    sx={{
                                      pt: 1,
                                      margin: "auto",
                                      width: "80%",
                                      objectFit: "cover",
                                    }}
                                    image={imageToShow}
                                    alt={subItem.name as string}
                                  />
                                  <Box
                                    sx={{
                                      position: "absolute" as "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                    }}
                                    onClick={() => {
                                      setTitle(subItem.name);
                                      setSliderImages(subItem.img);
                                      setOpen(true);
                                    }}
                                  >
                                    <ZoomInRounded
                                      sx={{
                                        color: "#fdd025",
                                        zIndex: 999,
                                        fontSize: "4rem",
                                        "&:hover": {
                                          fontSize: "6rem",
                                        },
                                      }}
                                    />
                                  </Box>
                                </Box>
                              )}

                              <CardContent>
                                <a href={subItem.path}>
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: "bold",
                                      color: theme.palette.primary.contrastText,
                                    }}
                                  >
                                    {subItem.name}
                                  </Typography>
                                </a>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        );
      })}
      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={
            <Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>
          }
        />
      )}
    </Stack>
  );
};

export default Department;
